// extracted by mini-css-extract-plugin
export default {"block":"EmptyMap_block__A33GE","text":"EmptyMap_text__u3CXl","boldText":"EmptyMap_boldText__R-FrH","emptyMapImg":"EmptyMap_emptyMapImg__gTYXO"};